<!-- 
catalog-db
created: yamada
updated:
-->
<template>
<div>
	<!-- label v-bind:class="[specialNavi.show ? 'level1 is-open' : 'level1']" v-on:click="toggleList(specialNavi)">特集から探す</label>
  <transition>
  <div v-show="specialNavi.show">
	<ul class="sub-nav__catalog-special">
		<li><router-link :to="{name: 'catlist', params: {Name: '新'}}">新入荷商品</router-link></li>
		<li><router-link :to="{name: 'catlist', params: {Name: 'おすすめ'}}">おすすめ商品</router-link></li>
		<li><router-link :to="{name: 'catlist', params: {Name: '災害'}}">災害支援商品</router-link></li>
	</ul>
  </div>
  </transition -->
	<label v-bind:class="[mainNavi.show ? 'level1 is-open' : 'level1']" v-on:click="toggleList(mainNavi)">機種一覧から探す</label>
	<transition>
	<div v-if="mainNavi.show">
        <div v-for="category in sortCategories" v-bind:key="category.id">
          <ul class="sub-nav__catalog-model1">
            <li>
              <label v-bind:class="[category.show ? 'level2 is-open' : 'level2']" v-on:click="toggleListInMainNavi(category, sortCategories)">
              {{category.name}}
              </label>
            </li>
            <transition>
            <div v-if="category.show">
              <ul class="sub-nav__catalog-model2">
                <div v-for="child in category.child" v-bind:key="child.id">
                  <li>
                    <div v-if="child.child.length > 0">
                      <label v-bind:class="[child.show ? 'level3 is-open' : 'level3']" v-on:click="toggleListInMainNavi(child, category.child)">
                        {{child.name}}
                      </label>
                    </div>
                    <div v-else>
                    <ul class="sub-nav__catalog-modellink">
                      <li>
                        <router-link class="product" :to="{ name: 'list', params: {Id: child.id}}">{{child.name}}</router-link>
                      </li>
                    </ul>
                    </div>
                  </li>
                  <transition>
                  <div v-if="child.show">
                    <ul class="sub-nav__catalog-modellink">
                    <div v-for="childone in child.child" v-bind:key="childone.id">
                      <li>
                        <router-link class="product" :to="{ name: 'list', params: {Id: childone.id}}">{{childone.name}}</router-link>
                      </li>
                    </div>
                    </ul>
                  </div>
                  </transition>
                </div>
              </ul>
            </div>
            </transition>
          </ul>
        </div>
	</div>
  </transition>
	<label v-bind:class="[docsNavi.show ? 'level1 is-open' : 'level1']" v-on:click="toggleList(docsNavi)">参考資料</label>
	<transition>
      <div v-show="docsNavi.show">
      <ul class="sub-nav__catalog-document">
        <li><a href="/../document/general-conditions.html">レンタル約款</a></li>
        <li><a href="/../document/rental-support.html">レンタル物件サポート特約制度</a></li>
        <li><a href="/../document/special-contract.html">レンタル保障制度</a></li>
        <li><a href="/../document/law.html">法規</a></li>
        <li><a href="/../document/qualification.html">資格</a></li>
        <li><a href="/../document/unit.html">単位</a></li>
        <li><a href="/../document/guide.html">ご利用ガイド</a></li>
      </ul>
      </div>
	</transition>
</div>
</template>

<style>
</style>

<script>	
  export default {
    data: function () {
      return {
				specialNavi: {
					show: false
				},
				mainNavi: {
					show: false
				},
				docsNavi: {
					show: false
				},
        sortCategories: [] //categories
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      this.sortCategories = this.categorySet
    },
    methods: {
      toggleList: function (menu){
        menu.show = !menu.show
      },
      toggleListInMainNavi: function (menu, uppermenus = []){
        for(var i=0;i<uppermenus.length;i++){
          uppermenus[i].show = false
        }
        this.mainNavi.show = false;
        menu.show = !menu.show;
        this.$nextTick(()=>{
          this.mainNavi.show = true;
        })
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
      }
    }
  }
</script>
